import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'
import moment from 'moment'

import { toWeekDaysArray, toDatesArray } from '../../../../helpers/moment'

const MonthView = ({
  history,
  location: { search },
  startDay,
  activeDate,
  activeMonth,
  setActiveDate,
  shifts,
  todayAttendanceRate,
  attendanceRates,
  todayFillRate,
  fillRates
}) => {
  const params = qs.parse(search)
  let activeClass = '  bg-brand text-white shadow-sm'

  const handleActiveDate = date => {
    setActiveDate(moment(date))

    history.push({
      pathname: `/smart-scheduler`,
      search: qs.stringify({
        ...params,
        date: moment(date).format('YYYY-MM-DD')
      })
    })
  }

  return (
    <div className="pt-4">
      <div className="d-flex">
        {toWeekDaysArray(moment(activeDate), startDay).map((day, index) => (
          <div
            key={index}
            className="flex-grow-1 pb-3 text-center fw-bold"
            style={{ flex: '0 13%' }}
          >
            {day}
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap">
        {toDatesArray(
          activeMonth.calendarStartDate,
          activeMonth.calendarEndDate
        ).map((date, index) => (
          <div
            aria-describedby={date}
            key={index}
            className="flex-grow-1 text-center"
            onClick={() => handleActiveDate(date)}
            style={{
              flex: '0 13%',
              paddingTop: '2rem',
              paddingBottom: '2rem',
              position: 'relative'
            }}
          >
            <div
              className={
                'pt-1 m-auto' +
                (moment(date).format('YYYY-MM-DD') ===
                moment(activeDate).format('YYYY-MM-DD')
                  ? activeClass
                  : '')
              }
              style={{
                borderRadius: '50%',
                height: '40px',
                width: '40px',
                textAlign: 'center',
                lineHeight: '2rem',
                fontSize: '1.4rem',
                cursor: 'pointer'
              }}
            >
              {moment(date).format('DD')}
            </div>
            {moment(date).format('YYYY-MM-DD') ===
              moment(activeDate).format('YYYY-MM-DD') && (
              <React.Fragment>
                {moment(activeDate) < moment() ? (
                  <React.Fragment>
                    {todayAttendanceRate && attendanceRates && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '-175px',
                          // left: '85px',
                          left: '-210px',
                          height: 'auto',
                          width: '250px',
                          backgroundColor: 'rgba(72, 72, 72, 0.01)',
                          borderRadius: '15px'
                        }}
                        className="bg-dark text-white"
                      >
                        <div className="d-flex flex-column container px-3 py-4">
                          <div className="d-flex justify-content-between border-bottom">
                            <strong>Attendance Rate</strong>
                            <p>{todayAttendanceRate.rate.toFixed(2)}%</p>
                          </div>
                          {shifts &&
                            shifts.map(shift => (
                              <div className="d-flex justify-content-between pt-2">
                                <strong>{shift.name}</strong>
                                <p>
                                  {attendanceRates
                                    .find(rate => rate.shift_id === shift.id)
                                    .rate.toFixed(2)}
                                  %
                                </p>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {todayFillRate && fillRates && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '-175px',
                          // left: '85px',
                          left: '-210px',
                          height: 'auto',
                          width: '250px',
                          backgroundColor: 'rgba(72, 72, 72, 0.01)',
                          borderRadius: '15px'
                        }}
                        className="bg-dark text-white"
                      >
                        <div className="d-flex flex-column container px-3 py-4">
                          <div className="d-flex justify-content-between border-bottom">
                            <strong>Fill Rate</strong>
                            <p>{todayFillRate.percentage.toFixed(2)}%</p>
                          </div>
                          {fillRates &&
                            fillRates.map(shift => (
                              <div className="d-flex justify-content-between pt-2">
                                <strong>{shift.name}</strong>
                                <p>
                                  {(shift.schedule
                                    ? (shift.schedule.filled_slots /
                                        shift.schedule.slots.slots) *
                                      100
                                    : 0
                                  ).toFixed(2)}
                                  %
                                </p>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default withRouter(MonthView)
